import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BankAccountsToDeductComponent } from '@payments/components/bank-accounts-to-deduct/bank-accounts-to-deduct.component';
import { BankDetailRowDesktopComponent } from '@payments/components/bank-detail-row/desktop/bank-detail-row-desktop.component';
import { BankDetailRowTouchComponent } from '@payments/components/bank-detail-row/touch/bank-detail-row-touch.component';
import { PaymentsSharedModule } from '@payments/payments-shared/payments-shared.module';
import { SharedModule } from '@shared/shared.module';
import { PaymentPreferencesPageRoutingModule } from './payment-preferences-routing.module';
import { PaymentPreferencesPage } from './payment-preferences.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    PaymentPreferencesPageRoutingModule,
    PaymentsSharedModule,
  ],
  declarations: [
    PaymentPreferencesPage,
    BankDetailRowDesktopComponent,
    BankDetailRowTouchComponent,
    BankAccountsToDeductComponent,
  ],
})
export class PaymentPreferencesPageModule {}
